export enum ClientQuestionnaireStatusEnum {
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS',
  Finalized = 'FINALIZED',
}
